import { Button, ListItemIcon, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import MessageRoundedIcon from '@mui/icons-material/MessageRounded';

const InstallmentShareModal = ({ invoice, onCopySuccess }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    
    
    const handleButtonShareClick = (event) => setAnchorEl(event.currentTarget);
    const handleButtonShareClickClose = () => setAnchorEl(null);
    const handleCopyLink = () => {
        navigator.clipboard.writeText(invoice?.installments[0].secure_url);
        handleButtonShareClickClose();
        onCopySuccess?.("Link copiado"); 
    };

    const message = `Olá! Aqui está o link para acessar a sua fatura referente aos serviços prestados: ${invoice?.installments[0].secure_url}`;

    const handleShareWhatsApp = () => {
        const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
        window.open(whatsappUrl, "_blank");
        handleButtonShareClickClose();
    };

    return (
        <>
            <Button
                color="primary"
                onClick={handleButtonShareClick}
                endIcon={
                    <ExpandMoreIcon
                        sx={{
                            transition: "transform 0.2s",
                            transform: open ? "rotate(-90deg)" : "rotate(0deg)",
                        }}
                    />
                }
                sx={{
                    width: '100%',
                    fontSize: '0.81rem',
                    whiteSpace: 'nowrap',
                }}
            >
                Compartilhar
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleButtonShareClickClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                sx={{
                    "& .MuiPaper-root": {
                        width: anchorEl ? anchorEl.offsetWidth : 'auto',
                    },
                }}
            >
                <MenuItem onClick={handleCopyLink}>
                    <ListItemIcon>
                        <ContentCopyRoundedIcon fontSize="small" />
                    </ListItemIcon>
                    Copiar link
                </MenuItem>
                <MenuItem onClick={handleShareWhatsApp}>
                    <ListItemIcon>
                        <MessageRoundedIcon fontSize="small" />
                    </ListItemIcon>
                    WhatsApp
                </MenuItem>
            </Menu>
        </>
    )
}

export default InstallmentShareModal;